import { Component, HostListener, OnInit } from '@angular/core';
import { urlEndPoint } from 'src/app/common';
import { Publication } from 'src/app/models/obs/publication';
import { PublicationService } from 'src/app/services/obs/publication.service';
declare var $;

@Component({
  selector: 'app-carousel-home-pubs',
  templateUrl: './carousel-home-pubs.component.html',
  styleUrl: './carousel-home-pubs.component.scss'
})

export class CarouselHomePubsComponent implements OnInit {
  URL: string = urlEndPoint;
  flatData: Publication[] = [];
  chunkedData: Publication[][] = [];
  itemsPerRow: number;

  constructor(private pubS: PublicationService) { }

  ngOnInit() {
    this.calculateItemsPerRow();
    this.getDataForSlider();
    this.loadCarousel();
  }

  loadCarousel() {
    $('.carousel').carousel({});
  }

  isArray(item: any): item is any[] {
    return Array.isArray(item);
  }

  getDataForSlider() {
    this.pubS.getAll4HomeCarousel().subscribe(
      {
        next: res => {
          const data: Publication[] = res['data'];
          this.flatData = data;
          this.chunkedData = this.chunkArray(data);
        },
        error: err => {
          console.error(err);
        }
      }
    );
  }

  private chunkArray(array: Publication[]): Publication[][] {
    const resultArray = [];
    const numChunks = Math.ceil(array.length / this.itemsPerRow);
    for (let i = 0; i < numChunks; i++) {
      const start = i * this.itemsPerRow;
      const end = (i + 1) * this.itemsPerRow;
      resultArray.push(array.slice(start, end));
    }
    return resultArray;
  }

  calculateItemsPerRow(): void {
    const screenWidth = window.innerWidth;
    if (screenWidth < 576) {
      this.itemsPerRow = 1;
    } else if (screenWidth < 768) {
      this.itemsPerRow = 2;
    } else if (screenWidth < 992) {
      this.itemsPerRow = 3;
    } else {
      this.itemsPerRow = 4;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.calculateItemsPerRow();
    this.chunkedData = this.chunkArray(this.flatData);
  }
}
